module.exports = __webpack_public_path__ + "static/media/MedicLogo.1dfae43d.svg";